import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from "sonner";

const EmojiVoting = ({ 
  onVote, 
  currentVote, 
  disabled = false,
  className = ""
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const feedbackOptions = [
    { 
      emoji: '🥶', 
      value: 'too_cold', 
      label: 'Too cold',
      description: 'I needed more layers'
    },
    { 
      emoji: '😊', 
      value: 'just_right', 
      label: 'Just right',
      description: 'Perfect recommendation'
    },
    { 
      emoji: '🥵', 
      value: 'too_warm', 
      label: 'Too warm',
      description: 'I needed fewer layers'
    }
  ];

  const handleVote = async (vote) => {
    if (disabled || isSubmitting || currentVote) return;
    
    setIsSubmitting(true);
    
    try {
      await onVote(vote);
      toast.success('Thanks for your feedback! This helps us improve recommendations.');
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      toast.error('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 shadow-lg border border-gray-200 dark:border-gray-700 ${className}`}>
      <h3 className="text-lg font-medium mb-3 text-center text-gray-800 dark:text-gray-200">
        How did this feel?
      </h3>
      
      <div className="flex justify-center space-x-4">
        {feedbackOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => handleVote(option.value)}
            disabled={disabled || isSubmitting || !!currentVote}
            className={`
              group flex flex-col items-center p-3 rounded-lg transition-all duration-200
              ${currentVote === option.value
                ? 'bg-blue-100 dark:bg-blue-900/30 scale-110 ring-2 ring-blue-500 dark:ring-blue-400'
                : currentVote
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 active:scale-95'
              }
              ${disabled || isSubmitting ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
            title={option.description}
          >
            <span className={`text-3xl mb-1 transition-transform duration-200 ${
              currentVote === option.value ? 'animate-bounce' : ''
            }`}>
              {option.emoji}
            </span>
            <span className="text-xs text-gray-600 dark:text-gray-400 font-medium">
              {option.label}
            </span>
            {currentVote === option.value && (
              <span className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                ✓ Submitted
              </span>
            )}
          </button>
        ))}
      </div>

      {isSubmitting && (
        <div className="flex items-center justify-center mt-3">
          <div className="animate-spin h-4 w-4 border-2 border-blue-500 rounded-full border-t-transparent mr-2"></div>
          <span className="text-sm text-gray-600 dark:text-gray-400">
            Submitting feedback...
          </span>
        </div>
      )}

      {currentVote && (
        <div className="text-center mt-3">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Your feedback helps improve recommendations for everyone
          </p>
        </div>
      )}
    </div>
  );
};

export default EmojiVoting;